import { GeneratorDataContent } from '@/api/interfaces/content/form/serviceDriven/generatorDataContent';
import { ConnectionRulesType } from '@/types/forms/shared/connectionRulesType';

export const generatorsContent: GeneratorDataContent[] = [
    {
        zerezId: '__MOCK_FRONTEND',
        manufacturerName: '__MOCK_FRONTEND',
        moduleType: '__MOCK_FRONTEND',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [
            ConnectionRulesType.rules4105,
            ConnectionRulesType.rules4110,
        ],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0001',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-40',
        activePower: 44.0,
        apparentPower: 47.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0002',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-50',
        activePower: 50.0,
        apparentPower: 54.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0003',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-60',
        activePower: 64.0,
        apparentPower: 69.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0004',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-70',
        activePower: 70.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0005',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-100',
        activePower: 100.0,
        apparentPower: 106.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0006',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-130',
        activePower: 133.0,
        apparentPower: 142.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0007',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-140',
        activePower: 142.0,
        apparentPower: 152.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0008',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-210',
        activePower: 210.0,
        apparentPower: 224.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0009',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-260',
        activePower: 263.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0010',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-300',
        activePower: 307.0,
        apparentPower: 326.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0011',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-350',
        activePower: 356.0,
        apparentPower: 379.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0012',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-430',
        activePower: 434.0,
        apparentPower: 462.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0013',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-500',
        activePower: 500.0,
        apparentPower: 532.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0014',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-530',
        activePower: 530.0,
        apparentPower: 561.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0015',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-40',
        activePower: 47.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0016',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-60',
        activePower: 64.0,
        apparentPower: 69.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0017',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-70',
        activePower: 75.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0018',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-100',
        activePower: 100.0,
        apparentPower: 105.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0019',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-190',
        activePower: 190.0,
        apparentPower: 203.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0020',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-210',
        activePower: 210.0,
        apparentPower: 224.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0021',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-252',
        activePower: 253.0,
        apparentPower: 270.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0022',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-300',
        activePower: 307.0,
        apparentPower: 326.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0023',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-350',
        activePower: 356.0,
        apparentPower: 379.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0024',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-404',
        activePower: 404.0,
        apparentPower: 426.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0025',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-430',
        activePower: 434.0,
        apparentPower: 462.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0026',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-500',
        activePower: 500.0,
        apparentPower: 532.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-SUF7-F0LF-0027',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-530',
        activePower: 530.0,
        apparentPower: 561.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-E9KH-SUJJ-0001',
        manufacturerName: 'Remeha GmbH',
        moduleType: 'eLecta Ace 300',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0001',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 16sw/-HT',
        activePower: 16.0,
        apparentPower: 17.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0002',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 16s/ -HT',
        activePower: 16.0,
        apparentPower: 17.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0003',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 20sw/-HT',
        activePower: 20.0,
        apparentPower: 21.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0004',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 22sw/ -HT',
        activePower: 22.0,
        apparentPower: 23.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0005',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 20s/ -HT',
        activePower: 20.0,
        apparentPower: 21.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0006',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 22s/ -HT',
        activePower: 22.0,
        apparentPower: 23.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0007',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 30sw/ -HT',
        activePower: 30.0,
        apparentPower: 31.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0008',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 30s/ -HT',
        activePower: 30.0,
        apparentPower: 31.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0009',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 33s/ -HT',
        activePower: 33.0,
        apparentPower: 34.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0010',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 50sw/ -HT/ 50T sw',
        activePower: 50.0,
        apparentPower: 52.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0011',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 50s/ -HT/ 50Ts',
        activePower: 50.0,
        apparentPower: 52.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0012',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 75sw/ -HT',
        activePower: 75.0,
        apparentPower: 78.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0013',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 75s/ -HT',
        activePower: 75.0,
        apparentPower: 78.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1QPP-T5FD-0014',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 100s / 100s HT',
        activePower: 100.0,
        apparentPower: 105.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OWP6-Z4HG-0001',
        manufacturerName: 'Energiewerkstatt GmbH & Co. KG',
        moduleType: 'Blockheizkraftwerk ASV 14',
        activePower: 14.0,
        apparentPower: 14.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OWP6-Z4HG-0002',
        manufacturerName: 'Energiewerkstatt GmbH & Co. KG',
        moduleType: 'Blockheizkraftwerk ASV 15',
        activePower: 15.0,
        apparentPower: 15.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OWP6-Z4HG-0003',
        manufacturerName: 'Energiewerkstatt GmbH & Co. KG',
        moduleType: 'Blockheizkraftwerk ASV 20',
        activePower: 20.0,
        apparentPower: 21.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OWP6-Z4HG-0004',
        manufacturerName: 'Energiewerkstatt GmbH & Co. KG',
        moduleType: 'Blockheizkraftwerk ASV 21',
        activePower: 21.0,
        apparentPower: 22.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OWP6-Z4HG-0005',
        manufacturerName: 'Energiewerkstatt GmbH & Co. KG',
        moduleType: 'Blockheizkraftwerk ASV 30',
        activePower: 30.0,
        apparentPower: 31.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OWP6-Z4HG-0006',
        manufacturerName: 'Energiewerkstatt GmbH & Co. KG',
        moduleType: 'Blockheizkraftwerk ASV 40',
        activePower: 40.0,
        apparentPower: 42.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-EHVJ-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: 'g-box 20',
        activePower: 20.0,
        apparentPower: 21.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-Q1C1-0001',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-105A-3',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-Q1C1-0002',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-145A-3',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-Q1C1-0003',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-169A-3',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-Q1C1-0004',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-206A-3',
        activePower: 103.0,
        apparentPower: 103.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-BQ7X-0001',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-032A-3 ',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-BQ7X-0002',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-038A-3',
        activePower: 18.5,
        apparentPower: 18.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-BQ7X-0003',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-045A-3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-BQ7X-0004',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-061A-3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-BQ7X-0005',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-072A-3',
        activePower: 37.0,
        apparentPower: 37.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-BQ7X-0006',
        manufacturerName: 'ABB AG',
        moduleType: ' ACS880-11-087A-3',
        activePower: 45.0,
        apparentPower: 45.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M4WR-8IGM-0003',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON E-160 EP5 E2 FT/FTS',
        activePower: 5500.0,
        apparentPower: 6200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M4WR-8IGM-0004',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON E-160 EP5 E2 FTQ/FTQS',
        activePower: 5500.0,
        apparentPower: 6500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M4WR-8IGM-0002',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON E-147 EP5 E2 FTQ/FTQS',
        activePower: 5000.0,
        apparentPower: 6000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M4WR-8IGM-0001',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON E-147 EP5 E2 FT/FTS',
        activePower: 5000.0,
        apparentPower: 5600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0001',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 600-12',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0002',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 600-24',
        activePower: 0.5,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0003',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1000-24',
        activePower: 0.8,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0004',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1200-24',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0005',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1000-48',
        activePower: 0.8,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0006',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1500-36',
        activePower: 1.3,
        apparentPower: 1.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0007',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1500-48',
        activePower: 1.3,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0008',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 2000-48',
        activePower: 1.6,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0009',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 2000-120',
        activePower: 1.6,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0010',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 2500-120',
        activePower: 1.9,
        apparentPower: 2.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0011',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 3000-120',
        activePower: 2.4,
        apparentPower: 2.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0012',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1600-120',
        activePower: 1.3,
        apparentPower: 1.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0013',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 2800-48',
        activePower: 2.2,
        apparentPower: 2.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0014',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 1000-160',
        activePower: 0.8,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-5LM6-0015',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'WIN 3200-48',
        activePower: 2.7,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '107 / g-box 50plus',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '108 / patruus 50',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '109 / patruus 64',
        activePower: 64.0,
        apparentPower: 71.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '110 / agenitor 404a',
        activePower: 80.0,
        apparentPower: 89.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '111 / aura 404',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '112 / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '113 / patruus 140',
        activePower: 140.0,
        apparentPower: 156.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '114 / agenitor 404c',
        activePower: 160.0,
        apparentPower: 178.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-FZBR-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '115 / aura 406',
        activePower: 170.0,
        apparentPower: 189.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '101 / agenitor 406',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '102 / patruus 263',
        activePower: 263.0,
        apparentPower: 292.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '103 / agenitor 408',
        activePower: 360.0,
        apparentPower: 400.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '104 / agenitor 412',
        activePower: 450.0,
        apparentPower: 500.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '105 / avus 500plus',
        activePower: 550.0,
        apparentPower: 611.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '106 / avus 1000plus',
        activePower: 1000.0,
        apparentPower: 1111.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '116 / agenitor 206',
        activePower: 220.0,
        apparentPower: 232.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '117 / aura 408',
        activePower: 280.0,
        apparentPower: 311.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '118 / patruus 370',
        activePower: 370.0,
        apparentPower: 389.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0010',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '119 / agenitor 212',
        activePower: 400.0,
        apparentPower: 421.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0011',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '120 / aura 412',
        activePower: 420.0,
        apparentPower: 467.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-1551-0012',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '121 / avus 1000plus \n(10kV Generator)',
        activePower: 1000.0,
        apparentPower: 1111.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '107 / g-box 50plus',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '108 / patruus 50',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '109 / patruus 64',
        activePower: 64.0,
        apparentPower: 71.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '110 / agenitor 404a',
        activePower: 80.0,
        apparentPower: 89.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '111 / aura 404',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '111a / aura 404',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '112 / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '112a / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '113 / patruus 140',
        activePower: 140.0,
        apparentPower: 156.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0010',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '114 / agenitor 404c',
        activePower: 160.0,
        apparentPower: 178.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0011',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '114a / agenitor 404c',
        activePower: 130.0,
        apparentPower: 144.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0012',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '114b / agenitor 404c',
        activePower: 160.0,
        apparentPower: 178.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0013',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '115 / aura 406',
        activePower: 170.0,
        apparentPower: 189.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0014',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '115a / aura 406',
        activePower: 200.0,
        apparentPower: 222.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0015',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '128 / 2G-KWK-190-BG',
        activePower: 190.0,
        apparentPower: 211.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-S4V6-0016',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '129 / 2G-KWK-100',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '101 / agenitor 406',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '101a / agenitor 406',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '101b / agenitor 406',
        activePower: 200.0,
        apparentPower: 222.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '101c / agenitor 406',
        activePower: 275.0,
        apparentPower: 306.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '102 / patruus 263',
        activePower: 263.0,
        apparentPower: 292.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '102a / patruus 263',
        activePower: 263.0,
        apparentPower: 292.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '103 / agenitor 408',
        activePower: 360.0,
        apparentPower: 400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '103a / agenitor 408',
        activePower: 360.0,
        apparentPower: 400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '103b / agenitor 408',
        activePower: 290.0,
        apparentPower: 322.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0010',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '104 / agenitor 412',
        activePower: 450.0,
        apparentPower: 500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0011',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '104a / agenitor 412',
        activePower: 420.0,
        apparentPower: 467.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0012',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '105 / avus 500plus',
        activePower: 550.0,
        apparentPower: 611.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0013',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '105a / avus 500plus',
        activePower: 600.0,
        apparentPower: 667.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0014',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '106 / avus 1000plus',
        activePower: 1000.0,
        apparentPower: 1111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0015',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '116 / agenitor 206',
        activePower: 220.0,
        apparentPower: 232.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0016',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '117 / aura 408',
        activePower: 280.0,
        apparentPower: 311.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0017',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '117a / aura 408',
        activePower: 280.0,
        apparentPower: 311.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0018',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '118 / patruus 370',
        activePower: 370.0,
        apparentPower: 389.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0019',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '119 / agenitor 212',
        activePower: 400.0,
        apparentPower: 421.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0020',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '119a / agenitor 212',
        activePower: 400.0,
        apparentPower: 421.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0021',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '120 / aura 412',
        activePower: 420.0,
        apparentPower: 467.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0022',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '120a / aura 412',
        activePower: 420.0,
        apparentPower: 467.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0023',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '121 / avus 1000plus \n(10kV Generator)',
        activePower: 1000.0,
        apparentPower: 1111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0024',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '122 / agenitor 306',
        activePower: 250.0,
        apparentPower: 263.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0025',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '123 / agenitor 408',
        activePower: 400.0,
        apparentPower: 444.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0026',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '124 / aura 416',
        activePower: 700.0,
        apparentPower: 778.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0027',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '125 / agenitor 416',
        activePower: 940.0,
        apparentPower: 1045.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0028',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '126 / agenitor 406',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-F47H-0029',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '127 / 2G-KWK-250-BGG',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '1 / g-box 50plus',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '2 / patruus 50',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '3 / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '3a / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '4 / patruus 64',
        activePower: 64.0,
        apparentPower: 71.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '5 / agenitor 404a',
        activePower: 80.0,
        apparentPower: 89.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '6 / aura 404',
        activePower: 134.0,
        apparentPower: 148.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '6a / aura 404',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '7 / patruus 140',
        activePower: 140.0,
        apparentPower: 156.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0010',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '7a / patruus 140',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0011',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '8 / agenitor 404c',
        activePower: 160.0,
        apparentPower: 178.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0012',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '8a / agenitor 404c',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0013',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '9 / aura 406',
        activePower: 170.0,
        apparentPower: 189.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1A6M-P17R-0014',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '9a / aura 406',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0001',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-40',
        activePower: 44.0,
        apparentPower: 46.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0002',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-50',
        activePower: 50.0,
        apparentPower: 53.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0003',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-130',
        activePower: 133.0,
        apparentPower: 141.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0004',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-40',
        activePower: 47.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0005',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-60',
        activePower: 64.0,
        apparentPower: 68.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0006',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-70',
        activePower: 70.0,
        apparentPower: 74.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0007',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK EG-100',
        activePower: 100.0,
        apparentPower: 105.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0008',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-60',
        activePower: 64.0,
        apparentPower: 68.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0009',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-70',
        activePower: 75.0,
        apparentPower: 79.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SUF7-9K3K-0010',
        manufacturerName: 'YADOS GmbH',
        moduleType: 'YADO|KWK BG-100',
        activePower: 100.0,
        apparentPower: 104.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-FMVU-0001',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-09A4-3',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-FMVU-0002',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-12A6-3 ',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-FMVU-0003',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-017A-3',
        activePower: 7.5,
        apparentPower: 7.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2CEZ-FMVU-0004',
        manufacturerName: 'ABB AG',
        moduleType: 'ACS880-11-025A-3',
        activePower: 11.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0001',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA086/xxx mit LSA 44.3 M8',
        activePower: 100.0,
        apparentPower: 123.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0002',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA095/xxx mit LSA 44.3 M8',
        activePower: 100.0,
        apparentPower: 123.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0003',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA095/xxx mit LSA 46.3 M7',
        activePower: 180.0,
        apparentPower: 243.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0004',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA136/xxx mit LSA 46.3 M7',
        activePower: 195.0,
        apparentPower: 248.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0005',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA136/xxx mit LSA 47.2 S4',
        activePower: 265.0,
        apparentPower: 333.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0006',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA136/xxx mit LSA 47.3 S5',
        activePower: 265.0,
        apparentPower: 333.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0007',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA168/xxx mit LSA 47.3 L9',
        activePower: 320.0,
        apparentPower: 416.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0008',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA222/xxx mit LSA 47.3 L9',
        activePower: 380.0,
        apparentPower: 464.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-RPYE-0009',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA252/xxx mit LSA 49.3 L9',
        activePower: 530.0,
        apparentPower: 665.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0001',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA086/xxx mit LSA 44.3 M8',
        activePower: 100.0,
        apparentPower: 123.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0002',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA095/xxx mit LSA 44.3 M8',
        activePower: 100.0,
        apparentPower: 123.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0003',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA095/xxx mit LSA 46.3 M7',
        activePower: 180.0,
        apparentPower: 243.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0004',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA136/xxx mit LSA 46.3 M7',
        activePower: 195.0,
        apparentPower: 248.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0005',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA136/xxx mit LSA 47.2 S4',
        activePower: 265.0,
        apparentPower: 333.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0006',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA136/xxx mit LSA 47.3 S5',
        activePower: 265.0,
        apparentPower: 333.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0007',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA168/xxx mit LSA 47.3 L9',
        activePower: 350.0,
        apparentPower: 416.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0008',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA222/xxx mit LSA 47.3 L9',
        activePower: 380.0,
        apparentPower: 464.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0009',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA252M/xxx mit LSA 49.3 L9',
        activePower: 530.0,
        apparentPower: 665.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Y6Y1-6DEC-0010',
        manufacturerName: 'AgriKomp GmbH',
        moduleType: 'XGA252L/xxx mit LSA 49.3 L9',
        activePower: 530.0,
        apparentPower: 665.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '207.0.0 / g-box 50plus',
        activePower: 50.0,
        apparentPower: 55.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '210.0.0 / agenitor 404a',
        activePower: 80.0,
        apparentPower: 88.9,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '211.0.0 / aura 404',
        activePower: 100.0,
        apparentPower: 111.1,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '211.1.0 / aura 404',
        activePower: 135.0,
        apparentPower: 168.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '212.0.0 / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.1,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '212.1.0 / agenitor 404b',
        activePower: 100.0,
        apparentPower: 111.1,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '213.0.0 / patruus 140',
        activePower: 140.0,
        apparentPower: 155.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '214.0.0 / agenitor 404c',
        activePower: 160.0,
        apparentPower: 177.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '214.0.1 / agenitor 404c',
        activePower: 180.0,
        apparentPower: 225.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0010',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '214.1.0 / agenitor 404c',
        activePower: 130.0,
        apparentPower: 144.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0011',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '215.0.0 / aura 406',
        activePower: 170.0,
        apparentPower: 188.9,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-2DLS-0012',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '215.0.1 / aura 406',
        activePower: 200.0,
        apparentPower: 222.2,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0001',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 50',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0002',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 65',
        activePower: 65.0,
        apparentPower: 72.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0003',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 75',
        activePower: 75.0,
        apparentPower: 83.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0004',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 75-1',
        activePower: 75.0,
        apparentPower: 83.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0005',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 99',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0006',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 100',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0007',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 135',
        activePower: 135.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0008',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 135-1',
        activePower: 135.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0009',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 150',
        activePower: 150.0,
        apparentPower: 167.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0010',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 190',
        activePower: 190.0,
        apparentPower: 211.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0011',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 190-1',
        activePower: 190.0,
        apparentPower: 211.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0012',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 210',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0013',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 210-1',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0014',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 210-2',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0015',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 250',
        activePower: 240.0,
        apparentPower: 267.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0016',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 250-1',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0017',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 250-2',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0018',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 300',
        activePower: 300.0,
        apparentPower: 333.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0019',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 300-1',
        activePower: 300.0,
        apparentPower: 333.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0020',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 350',
        activePower: 350.0,
        apparentPower: 388.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0021',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 350-1',
        activePower: 350.0,
        apparentPower: 388.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0022',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 400',
        activePower: 400.0,
        apparentPower: 444.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0023',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 400-1',
        activePower: 400.0,
        apparentPower: 444.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0024',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 430',
        activePower: 430.0,
        apparentPower: 478.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0025',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 430-1',
        activePower: 430.0,
        apparentPower: 478.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0026',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 530',
        activePower: 530.0,
        apparentPower: 589.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GCK0-ONBP-0027',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 710',
        activePower: 710.0,
        apparentPower: 789.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0001',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '201.0.0 / agenitor 406',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0002',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '201.0.1 / agenitor 406',
        activePower: 275.0,
        apparentPower: 306.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0003',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '201.1.0 / agenitor 406',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0004',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '201.1.1 / agenitor 406',
        activePower: 275.0,
        apparentPower: 344.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0005',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '202.0.0 / patruus 263',
        activePower: 263.0,
        apparentPower: 292.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0006',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '203.0.0 / agenitor 408',
        activePower: 360.0,
        apparentPower: 400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0007',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '203.0.1 / agenitor 408',
        activePower: 400.0,
        apparentPower: 500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0008',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '203.1.0 / agenitor 408',
        activePower: 360.0,
        apparentPower: 400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0009',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '203.2.0 / agenitor 408',
        activePower: 360.0,
        apparentPower: 400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0010',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '204.0.0 / agenitor 412',
        activePower: 450.0,
        apparentPower: 500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0011',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '204.0.1 / agenitor 412',
        activePower: 500.0,
        apparentPower: 625.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0012',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '205.0.0 / avus 500plus',
        activePower: 550.0,
        apparentPower: 611.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0013',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '205.0.1 / avus 500plus',
        activePower: 600.0,
        apparentPower: 750.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0014',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '205.1.0 / avus 500plus',
        activePower: 550.0,
        apparentPower: 688.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0015',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '206.0.0 / avus 1000plus',
        activePower: 1000.0,
        apparentPower: 1111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0016',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '206.0.1 / avus 1000plus',
        activePower: 1100.0,
        apparentPower: 1375.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0017',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '217.0.0 / aura 408',
        activePower: 280.0,
        apparentPower: 311.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0018',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '217.1.0 / aura 408',
        activePower: 280.0,
        apparentPower: 311.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0019',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '220.0.0 / aura 412',
        activePower: 420.0,
        apparentPower: 467.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0020',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '220.1.0 / aura 412',
        activePower: 420.0,
        apparentPower: 467.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0021',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '221.0.0 / avus 1000plus\n(10kV Generator)',
        activePower: 1000.0,
        apparentPower: 1111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0022',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '224.0.0 / aura 416',
        activePower: 700.0,
        apparentPower: 875.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0023',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '230.0.0 / avus 416plus',
        activePower: 940.0,
        apparentPower: 1175.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0024',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '230.0.1 / avus 416plus',
        activePower: 800.0,
        apparentPower: 1000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1A6M-CRCJ-0025',
        manufacturerName: '2G Energietechnik GmbH',
        moduleType: '230.0.2 / avus 416 plus',
        activePower: 865.0,
        apparentPower: 1081.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0001',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 70 EG',
        activePower: 70.0,
        apparentPower: 78.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0002',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 100 EG',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0003',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 138 EG',
        activePower: 138.0,
        apparentPower: 153.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0004',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 165 HGB',
        activePower: 165.0,
        apparentPower: 183.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0005',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 180 HG',
        activePower: 180.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0006',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 180 HGB',
        activePower: 180.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0007',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 210 EGB',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0008',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 220 HG',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0009',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 220 EG',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0010',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 240 EG',
        activePower: 240.0,
        apparentPower: 267.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0011',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 250 HG',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0012',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 250 HGB',
        activePower: 250.0,
        apparentPower: 278.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0013',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 265 EG',
        activePower: 265.0,
        apparentPower: 294.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0014',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 340 HG',
        activePower: 340.0,
        apparentPower: 378.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0015',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 355 EG',
        activePower: 355.0,
        apparentPower: 394.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0016',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 530 HG',
        activePower: 530.0,
        apparentPower: 589.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0017',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 23 HG',
        activePower: 23.0,
        apparentPower: 26.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0018',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 29 HG',
        activePower: 29.0,
        apparentPower: 32.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0019',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 40 HG',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0020',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 50 HG',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0021',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 132 EG',
        activePower: 132.0,
        apparentPower: 147.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0022',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 200',
        activePower: 200.0,
        apparentPower: 222.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0023',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 200 HG',
        activePower: 200.0,
        apparentPower: 222.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0024',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 220',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-53O7-0025',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 495',
        activePower: 495.0,
        apparentPower: 550.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0001',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 70 EG',
        activePower: 70.0,
        apparentPower: 78.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0002',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 100 EG',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0003',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 23 HG',
        activePower: 23.0,
        apparentPower: 26.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0004',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 29 HG',
        activePower: 29.0,
        apparentPower: 32.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0005',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 40 HG',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0006',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 50 HG',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0007',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 132 EG',
        activePower: 132.0,
        apparentPower: 147.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0008',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 138 EG',
        activePower: 138.0,
        apparentPower: 153.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0009',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 165 HGB',
        activePower: 165.0,
        apparentPower: 183.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0010',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 180 HG',
        activePower: 180.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0011',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 180 HGB',
        activePower: 180.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0012',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 200',
        activePower: 200.0,
        apparentPower: 222.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0013',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 200 HG',
        activePower: 200.0,
        apparentPower: 222.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0014',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 210 EGB',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0015',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 220',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0016',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 220 EG',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-H41V-KV8W-0017',
        manufacturerName: 'Burkhardt GmbH',
        moduleType: 'ECO 220 HG',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0001',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 50',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0002',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 65',
        activePower: 65.0,
        apparentPower: 72.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0003',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 75',
        activePower: 75.0,
        apparentPower: 83.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0004',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 75-1',
        activePower: 75.0,
        apparentPower: 83.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0005',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 99',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0006',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 100',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0007',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 135',
        activePower: 135.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0008',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 135-1',
        activePower: 135.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0009',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 150',
        activePower: 150.0,
        apparentPower: 167.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0010',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 190',
        activePower: 190.0,
        apparentPower: 211.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0011',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 190-1',
        activePower: 190.0,
        apparentPower: 211.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0012',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 210',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0013',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 210-1',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GCK0-E5LL-0014',
        manufacturerName: 'Elektro Hagl KG',
        moduleType: 'HBG 210-2',
        activePower: 210.0,
        apparentPower: 233.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M4WR-HMF2-0002',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON E-147 EP5 FTQ/FTQS',
        activePower: 4300.0,
        apparentPower: 5200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M4WR-HMF2-0003',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON L147 LP4 FT/FTS',
        activePower: 4300.0,
        apparentPower: 5000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M4WR-HMF2-0004',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON L147 LP4 FTQ/FTQS',
        activePower: 4300.0,
        apparentPower: 5200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M4WR-HMF2-0001',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'ENERCON E-147 EP5 FT/FTS',
        activePower: 4300.0,
        apparentPower: 5000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0010',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-401/549',
        activePower: 401.0,
        apparentPower: 445.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0008',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 140 -1 -X',
        activePower: 140.0,
        apparentPower: 156.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0010',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-140/207',
        activePower: 140.0,
        apparentPower: 156.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0007',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 220 -1 -X',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0006',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 199 -1 -X',
        activePower: 199.0,
        apparentPower: 221.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0005',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 134 -1 -X',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0004',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 100 -2 -X',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0003',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 100 -1 -X',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0002',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 70 -1 -X',
        activePower: 70.0,
        apparentPower: 78.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IO4U-0001',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 50 -1 -X',
        activePower: 50.0,
        apparentPower: 56.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0009',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-220/346',
        activePower: 220.0,
        apparentPower: 244.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0008',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-199/293',
        activePower: 199.0,
        apparentPower: 221.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0007',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-199/263',
        activePower: 199.0,
        apparentPower: 221.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0006',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-134/202',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0005',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-134/201',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0004',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-100/173',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0003',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-100/167',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0002',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-70/115',
        activePower: 70.0,
        apparentPower: 77.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-CRL0-0001',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-50/81',
        activePower: 50.0,
        apparentPower: 55.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0010',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 530 -2 -X',
        activePower: 530.0,
        apparentPower: 589.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0009',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 530 -1 -X',
        activePower: 530.0,
        apparentPower: 589.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0008',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 430 -2 -X',
        activePower: 435.0,
        apparentPower: 483.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0007',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 430 -1 -X',
        activePower: 435.0,
        apparentPower: 483.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0006',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 260 -1 -X',
        activePower: 263.0,
        apparentPower: 292.2,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0005',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 220 -1 -X',
        activePower: 220.0,
        apparentPower: 244.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0004',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 140 -1 -X',
        activePower: 140.0,
        apparentPower: 155.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0003',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 134 -1 -X',
        activePower: 134.0,
        apparentPower: 149.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0002',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 100 -1 -X',
        activePower: 99.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-4VMX-0001',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 70-1-X',
        activePower: 70.0,
        apparentPower: 77.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0012',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-530/660',
        activePower: 530.0,
        apparentPower: 589.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0011',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-430/580',
        activePower: 435.0,
        apparentPower: 483.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0009',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-363/498',
        activePower: 363.0,
        apparentPower: 403.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0008',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-363/497',
        activePower: 363.0,
        apparentPower: 403.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0007',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-324/458',
        activePower: 324.0,
        apparentPower: 360.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0006',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-260/390',
        activePower: 263.0,
        apparentPower: 292.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0005',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-238/363',
        activePower: 238.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0004',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-220/346',
        activePower: 220.0,
        apparentPower: 244.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0003',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-199/293',
        activePower: 199.0,
        apparentPower: 221.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0002',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-199/263',
        activePower: 199.0,
        apparentPower: 221.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-UFE0-0001',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-140/207',
        activePower: 140.0,
        apparentPower: 155.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RF18-0IVD-0002',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-9/20',
        activePower: 8.5,
        apparentPower: 9.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-0IVD-0003',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-20/39',
        activePower: 20.0,
        apparentPower: 22.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-0IVD-0001',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 EM-6/15',
        activePower: 6.0,
        apparentPower: 6.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0006',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 300 NG 20 -2 -X',
        activePower: 20.0,
        apparentPower: 21.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0007',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 300 NG 9 -2 -X',
        activePower: 8.5,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0005',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 300 NG 15 -1 -X',
        activePower: 15.0,
        apparentPower: 16.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0004',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 300 NG 6 -2 -X',
        activePower: 6.0,
        apparentPower: 6.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0003',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 20 -1 -X',
        activePower: 20.0,
        apparentPower: 21.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0001',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 6 -1 -X',
        activePower: 6.0,
        apparentPower: 6.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RF18-IQTT-0002',
        manufacturerName: 'Viessmann Kraft-Wärme-Kopplung GmbH',
        moduleType: 'VITOBLOC 200 NG 9 -1 -X',
        activePower: 8.5,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NICT-77EH-0001',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'E-160 EP5 E3 FT',
        activePower: 5560.0,
        apparentPower: 6200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NICT-77EH-0002',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'E-160 EP5 E3 FTS',
        activePower: 5560.0,
        apparentPower: 6200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NICT-77EH-0003',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'E-160 EP5 E3 FTQ',
        activePower: 5560.0,
        apparentPower: 6500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NICT-77EH-0004',
        manufacturerName: 'ENERCON Global GmbH',
        moduleType: 'E-160 EP5 E3 FTQS',
        activePower: 5560.0,
        apparentPower: 6500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WF3P-MVYZ-0001',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA70 (1-25)',
        activePower: 68.0,
        apparentPower: 76.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WF3P-MVYZ-0002',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA70 (26-46)',
        activePower: 68.0,
        apparentPower: 76.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WF3P-MVYZ-0003',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA70 (47 und folgende)',
        activePower: 68.0,
        apparentPower: 76.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WF3P-MVYZ-0004',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA49',
        activePower: 49.0,
        apparentPower: 54.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WF3P-MVYZ-0005',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA50 V2',
        activePower: 49.0,
        apparentPower: 54.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WF3P-G6CB-0001',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA70 (1-25)',
        activePower: 68.0,
        apparentPower: 76.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-WF3P-G6CB-0002',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA70 (26-46)',
        activePower: 68.0,
        apparentPower: 76.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-WF3P-G6CB-0003',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA70 (47 und folgende)',
        activePower: 68.0,
        apparentPower: 76.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-WF3P-G6CB-0004',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA49',
        activePower: 49.0,
        apparentPower: 54.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-WF3P-G6CB-0005',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA50 V2',
        activePower: 49.0,
        apparentPower: 54.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-WF3P-G6CB-0006',
        manufacturerName: 'Spanner Re² GmbH',
        moduleType: 'HKA35',
        activePower: 35.0,
        apparentPower: 39.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-2LUM-ZAHQ-0001',
        manufacturerName: 'VENSYS Energy AG',
        moduleType: 'VENSYS 126',
        activePower: 3800.0,
        apparentPower: 4221.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-2LUM-VVBB-0001',
        manufacturerName: 'VENSYS Energy AG',
        moduleType: 'VENSYS 112',
        activePower: 2500.0,
        apparentPower: 2777.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-2LUM-P4ON-0001',
        manufacturerName: 'VENSYS Energy AG',
        moduleType: 'VENSYS 120',
        activePower: 3000.0,
        apparentPower: 3333.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-2LUM-AZQD-0001',
        manufacturerName: 'VENSYS Energy AG',
        moduleType: 'VENSYS 136',
        activePower: 3500.0,
        apparentPower: 3888.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0001',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH75M',
        activePower: 70.0,
        apparentPower: 77.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0002',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH110M',
        activePower: 103.0,
        apparentPower: 114.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0003',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH130M',
        activePower: 122.0,
        apparentPower: 135.5,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0004',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH150M',
        activePower: 142.0,
        apparentPower: 157.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0005',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH210M',
        activePower: 200.0,
        apparentPower: 222.2,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0006',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH220M',
        activePower: 210.0,
        apparentPower: 233.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0007',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH275M',
        activePower: 264.0,
        apparentPower: 293.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0008',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH320M',
        activePower: 308.0,
        apparentPower: 342.2,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0009',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH370M',
        activePower: 357.0,
        apparentPower: 396.7,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0010',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH450M',
        activePower: 435.0,
        apparentPower: 483.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-WP3Y-1CK1-0011',
        manufacturerName: 'Lek/Habo',
        moduleType: 'LH550M',
        activePower: 528.0,
        apparentPower: 586.7,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0001',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 16sw/ -HT',
        activePower: 16.0,
        apparentPower: 17.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0002',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 16s/ -HT',
        activePower: 16.0,
        apparentPower: 17.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0003',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 20sw/ -HT',
        activePower: 20.0,
        apparentPower: 22.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0004',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 22sw/ -HT',
        activePower: 22.0,
        apparentPower: 24.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0005',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 20s/- HT',
        activePower: 20.0,
        apparentPower: 22.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0006',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 22s/ -HT',
        activePower: 22.0,
        apparentPower: 24.4,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0007',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 30sw/ -HT',
        activePower: 30.0,
        apparentPower: 33.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0008',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 30s/ -HT',
        activePower: 30.0,
        apparentPower: 33.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0009',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 33s/ -HT',
        activePower: 33.0,
        apparentPower: 36.7,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0010',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 50sw/ -HT/ 50T sw',
        activePower: 50.0,
        apparentPower: 55.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0011',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 50s/ -HT/50Ts',
        activePower: 50.0,
        apparentPower: 55.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0012',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 75sw/ -HT',
        activePower: 75.0,
        apparentPower: 83.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0013',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 75s/ -HT',
        activePower: 75.0,
        apparentPower: 83.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0014',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 100s/ -HT',
        activePower: 100.0,
        apparentPower: 111.1,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1QPP-XQW9-0015',
        manufacturerName: 'KW Energie GmbH & Co. KG',
        moduleType: 'smartblock 150s/ -HT',
        activePower: 150.0,
        apparentPower: 166.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-07UA-LOUE-0001',
        manufacturerName: 'SIEMENS AG',
        moduleType:
            'S120 Booksize - Active Line Modul 120kW mit Erweiterung nach VDE AR-N 4105',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-07UA-LOUE-0002',
        manufacturerName: 'SIEMENS AG',
        moduleType:
            'S120 Booksize - Active Line Modul 80kW mit Erweiterung nach VDE AR-N 4105',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-07UA-LOUE-0003',
        manufacturerName: 'SIEMENS AG',
        moduleType:
            'S120 Booksize - Active Line Modul 55kW mit Erweiterung nach VDE AR-N 4105',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-07UA-LOUE-0004',
        manufacturerName: 'SIEMENS AG',
        moduleType:
            'S120 Booksize - Active Line Modul 36kW mit Erweiterung nach VDE AR-N 4105',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-07UA-LOUE-0005',
        manufacturerName: 'SIEMENS AG',
        moduleType:
            'S120 Booksize - Active Line Modul 16kW mit Erweiterung nach VDE AR-N 4105',
        activePower: 16.0,
        apparentPower: 16.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
];
